"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _reactFinalForm = require("react-final-form");
var _components = require("@folio/stripes/components");
var _validators = require("../../validators");
var _useValueProps = _interopRequireDefault(require("./useValueProps"));
var _useOperators = _interopRequireDefault(require("./useOperators"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  ariaLabelledby: _propTypes.default.string.isRequired,
  clearRuleValue: _propTypes.default.func.isRequired,
  index: _propTypes.default.number.isRequired,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  name: _propTypes.default.string.isRequired,
  onDelete: _propTypes.default.func.isRequired,
  custPropDefinition: _propTypes.default.shape({
    type: _propTypes.default.string,
    category: _propTypes.default.shape({
      values: _propTypes.default.arrayOf(_propTypes.default.object)
    })
  }),
  value: _propTypes.default.shape({
    operator: _propTypes.default.string,
    value: _propTypes.default.string
  })
};
const CustomPropertiesRule = _ref => {
  let {
    ariaLabelledby,
    clearRuleValue,
    index,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    name,
    onDelete,
    custPropDefinition = {},
    value
  } = _ref;
  const operators = (0, _useOperators.default)(custPropDefinition.type, passedIntlKey, passedIntlNS, labelOverrides);
  const valueProps = (0, _useValueProps.default)(custPropDefinition, passedIntlKey, passedIntlNS, labelOverrides);
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const selectedOperator = operators.find(o => o.value === value?.operator);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
      xs: 2,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Layout, {
        className: "textCentered",
        children: index === 0 ? null : kintIntl.formatKintMessage({
          id: 'OR',
          overrideValue: labelOverrides.OR
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
      xs: 4,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
        name: `${name}.operator`,
        validate: _validators.required,
        children: _ref2 => {
          let {
            input,
            meta
          } = _ref2;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Select, {
            ...input,
            "aria-labelledby": `${ariaLabelledby}-rule-column-header-comparator`,
            dataOptions: operators,
            error: meta?.touched && meta?.error,
            onChange: e => {
              input.onChange(e);
              const newlySelectedOperator = operators.find(o => o.value === e.target.value);
              if (newlySelectedOperator?.noValueAllowed) {
                clearRuleValue();
              }
            },
            placeholder: " ",
            required: true
          });
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
      xs: 4,
      children: selectedOperator?.noValueAllowed ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
        "aria-labelledby": `${ariaLabelledby}-rule-column-header-value`,
        name: `${name}.value`,
        required: true,
        validate: _validators.required,
        ...valueProps
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
      xs: 2,
      children: index ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Tooltip, {
        id: (0, _lodash.uniqueId)('delete-rule-btn'),
        text: kintIntl.formatKintMessage({
          id: 'customProperty.removeRule',
          overrideValue: labelOverrides.removeRule
        }, {
          number: index + 1
        }),
        children: _ref3 => {
          let {
            ref,
            ariaIds
          } = _ref3;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
            ref: ref,
            "aria-labelledby": ariaIds.text,
            icon: "trash",
            onClick: onDelete
          });
        }
      }) : null
    })]
  }, name);
};
CustomPropertiesRule.propTypes = propTypes;
var _default = exports.default = CustomPropertiesRule;